import { Box, Flex, Skeleton } from '@skin-seoul/design-system';
export const LoyaltyPointsBannerSkeleton = () => {
  return <Box position="relative" width="100%" borderRadius="8px" bg="neutral.100" overflow="hidden" px={4} py={{
    base: 6,
    tablet: 4
  }} data-sentry-element="Box" data-sentry-component="LoyaltyPointsBannerSkeleton" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx">
      <Flex position="relative" zIndex={1} alignItems="center" justifyContent="space-between" height="100%" data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx">
        {/* Title Skeleton */}
        <Flex direction="column" gap={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx">
          <Skeleton height="20px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx" />
          <Skeleton height="20px" width="100px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx" />
        </Flex>

        {/* Points Skeleton */}
        <Flex direction="column" gap={1} alignItems="flex-end" data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx">
          <Skeleton height="14px" width="70px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx" />
          <Skeleton height="24px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyPointsBannerSkeleton.tsx" />
        </Flex>
      </Flex>
    </Box>;
};